function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-content">
        <p>© 2026 Dylan Tomlinson. Built with React.</p>
      </div>
    </footer>
  );
}

export default Footer;